module.exports = __webpack_public_path__ + "img/back_width.40d9adc6.png";